import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['pack', 'price'];

    connect() {
        this.bindPackPriceListener();
    }

    bindPackPriceListener() {
        if (!this.hasPackTarget) {
            return;
        }

        const select = this.packTarget;
        select.addEventListener('change', () => this.applyPackPrice());

        const bindTomSelect = () => {
            if (select.tomselect) {
                select.tomselect.on('change', () => this.applyPackPrice());

                return true;
            }

            return false;
        };

        if (!bindTomSelect()) {
            window.addEventListener('load', () => bindTomSelect(), { once: true });
            setTimeout(() => bindTomSelect(), 150);
        }
    }

    applyPackPrice() {
        if (!this.hasPackTarget || !this.hasPriceTarget) {
            return;
        }

        const select = this.packTarget;
        const value = select.tomselect?.getValue() ?? select.value;
        if (value === '' || value === null) {
            return;
        }

        const option =
            select.querySelector(`option[value="${CSS.escape(String(value))}"]`) ??
            select.selectedOptions[0];
        if (!option) {
            return;
        }

        const packPrice = option.dataset.price;
        if (packPrice !== undefined && packPrice !== '') {
            this.priceTarget.value = packPrice;
        }
    }
}
